
<span>
  <button
    class="WBMBigButton m-primary"
    v-on:click.prevent="onCopy"
    v-if="!isCopied"
  >
    Copy
  </button>
  <button
    class="WBMBigButton m-primary"
    v-on:click.prevent="onCopy"
    v-if="isCopied"
  >
    <span class="HiddenText">Copy</span>
    <span class="OverlayText">👍🏻</span>
  </button>
</span>
